import AsyncCreatableSelect from 'react-select/async-creatable'
import debounce from 'debounce-async'
import { useMemo } from 'react'
import axios from 'axios'
import { Get_Metadata } from '../../../../api/api'

const MetadataSelect = ({ type, placeholder, value, onChange, isMulti = false }) => {
  const loadOptions = useMemo(() => {
    return debounce(async (inputValue) => {
      if (!inputValue?.trim()) return []

      const { data } = await axios.get(Get_Metadata(type, inputValue.trim()))

      return data.map((item) => ({
        value: item.id,
        label: item.title,
      }))
    }, 300)
  }, [type])

  const handleCreate = (inputValue) => {
    const option = { value: inputValue, label: inputValue, __isNew__: true }

    if (isMulti) {
      onChange([...(value || []), option])
      return
    }

    onChange(option)
  }

  return (
    <div style={{ marginBottom: '1rem' }}>
      <AsyncCreatableSelect
        cacheOptions
        placeholder={placeholder}
        value={value}
        loadOptions={loadOptions}
        onChange={onChange}
        onCreateOption={handleCreate}
        isClearable
        isMulti={isMulti}
        isRtl
        openMenuOnFocus={false}
        formatCreateLabel={(inputValue) => `ایجاد «${inputValue}»`}
        noOptionsMessage={({ inputValue }) =>
          inputValue?.trim()
            ? 'موردی یافت نشد — می‌توانید مقدار جدید وارد کنید'
            : 'برای جستجو شروع به تایپ کنید'
        }
        loadingMessage={() => 'لطفا صبر کنید...'}
      />
    </div>
  )
}

export const buildMetadataPayload = (values) => {
  const fields = [
    { key: 'developer', type: 0 },
    { key: 'publisher', type: 1 },
    { key: 'collection', type: 2 },
    { key: 'country', type: 3 },
  ]

  return fields.flatMap(({ key, type }) =>
    (values[key] || [])
      .filter((option) => option?.label?.trim())
      .map((option) => ({
        type,
        title: option.label.trim(),
      }))
  )
}

export const parseMetadataDefaults = (metadata = []) => {
  const getTypeId = (item) => item.type?.id ?? item.type

  const findAll = (type) =>
    metadata
      .filter((item) => getTypeId(item) === type)
      .map((item) => ({ value: item.id ?? item.title, label: item.title }))

  return {
    developer: findAll(0),
    publisher: findAll(1),
    collection: findAll(2),
    country: findAll(3),
  }
}

export default MetadataSelect
